// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-img-result-searcher {
    background-color: lightgrey;
    height: 100%;
}

.container-img-result-searcher img[data-main-img] {
    view-transition-name: main-image;
}

.container-img-result-searcher:hover {
    .img-title-description,
    [data-similar-images-icon],
    .img-icons {
        display: flex;
        transition: opacity 0.4s ease-in-out;
        opacity: 1;
    }

    .img-title-description {
        height: auto;
        max-height: 80%;
    }

    .img-title-description-show {
        & > h3,
        & > p:last-child {
            display: -webkit-box;
            opacity: 1;
            transition: opacity 0.4s ease-in-out;
        }
    }

    .img-title-description-search-img-card {
        [data-video-caption] {
            display: -webkit-box !important;
            opacity: 1;
            transition: opacity 0.4s ease-in-out;
        }
    }
}

.container-img-result-searcher .img-title-description {
    gap: 5px;
    padding: 5px;
    position: absolute;
    bottom: 0px;
    opacity: 0;

    & > * {
        margin: 1px;
    }

    & > p {
        margin-inline-end: 5px;
    }

    & [data-video-caption] {
        display: none;
    }
}

.container-img-result-searcher .img-title-description-show {
    opacity: 1 !important;
    display: flex !important;

    & > p:first-child {
        display: flex;
    }

    & > h3,
    & > p:last-child {
        display: none;
        opacity: 0;
    }
}

.container-img-result-searcher .img-title-description-search-img-card {
    display: flex !important;
    opacity: 1;
    height: auto;

    [data-video-caption] {
        display: none !important;
        opacity: 0;
    }
}

.container-img-result-searcher .img-icons {
    gap: 5px;
    padding: 5px;
    justify-content: flex-end;
    opacity: 0;
    display: flex;
    width: fit-content;
    max-width: 300px;
    background-color: transparent;
    max-height: 50px;
}

.container-img-result-searcher .options-download-modal {
    flex-direction: column;
    align-items: center;
}

.container-img-result-searcher .img-extra-icons-inside-card {
    position: absolute;
    bottom: 0;
    right: 0;
}

.container-img-result-searcher [data-extra-img-icons],
.container-img-result-searcher [data-generative-ai-icon],
.container-img-result-searcher [data-premium-icon] {
    opacity: 1 !important;
    display: none;
}

.container-img-result-searcher [data-similar-images-icon] {
    display: none;
}

.overlay {
    position: absolute;
}
`, "",{"version":3,"sources":["webpack://./../components/src/layouts/ResultsGridLayout/components/SearchImgCardComponent/SearchImgCardComponent.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;;;QAGI,aAAa;QACb,oCAAoC;QACpC,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI;;YAEI,oBAAoB;YACpB,UAAU;YACV,oCAAoC;QACxC;IACJ;;IAEA;QACI;YACI,+BAA+B;YAC/B,UAAU;YACV,oCAAoC;QACxC;IACJ;AACJ;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,UAAU;;IAEV;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;;IAExB;QACI,aAAa;IACjB;;IAEA;;QAEI,aAAa;QACb,UAAU;IACd;AACJ;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,YAAY;;IAEZ;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;;;IAGI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".container-img-result-searcher {\n    background-color: lightgrey;\n    height: 100%;\n}\n\n.container-img-result-searcher img[data-main-img] {\n    view-transition-name: main-image;\n}\n\n.container-img-result-searcher:hover {\n    .img-title-description,\n    [data-similar-images-icon],\n    .img-icons {\n        display: flex;\n        transition: opacity 0.4s ease-in-out;\n        opacity: 1;\n    }\n\n    .img-title-description {\n        height: auto;\n        max-height: 80%;\n    }\n\n    .img-title-description-show {\n        & > h3,\n        & > p:last-child {\n            display: -webkit-box;\n            opacity: 1;\n            transition: opacity 0.4s ease-in-out;\n        }\n    }\n\n    .img-title-description-search-img-card {\n        [data-video-caption] {\n            display: -webkit-box !important;\n            opacity: 1;\n            transition: opacity 0.4s ease-in-out;\n        }\n    }\n}\n\n.container-img-result-searcher .img-title-description {\n    gap: 5px;\n    padding: 5px;\n    position: absolute;\n    bottom: 0px;\n    opacity: 0;\n\n    & > * {\n        margin: 1px;\n    }\n\n    & > p {\n        margin-inline-end: 5px;\n    }\n\n    & [data-video-caption] {\n        display: none;\n    }\n}\n\n.container-img-result-searcher .img-title-description-show {\n    opacity: 1 !important;\n    display: flex !important;\n\n    & > p:first-child {\n        display: flex;\n    }\n\n    & > h3,\n    & > p:last-child {\n        display: none;\n        opacity: 0;\n    }\n}\n\n.container-img-result-searcher .img-title-description-search-img-card {\n    display: flex !important;\n    opacity: 1;\n    height: auto;\n\n    [data-video-caption] {\n        display: none !important;\n        opacity: 0;\n    }\n}\n\n.container-img-result-searcher .img-icons {\n    gap: 5px;\n    padding: 5px;\n    justify-content: flex-end;\n    opacity: 0;\n    display: flex;\n    width: fit-content;\n    max-width: 300px;\n    background-color: transparent;\n    max-height: 50px;\n}\n\n.container-img-result-searcher .options-download-modal {\n    flex-direction: column;\n    align-items: center;\n}\n\n.container-img-result-searcher .img-extra-icons-inside-card {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n\n.container-img-result-searcher [data-extra-img-icons],\n.container-img-result-searcher [data-generative-ai-icon],\n.container-img-result-searcher [data-premium-icon] {\n    opacity: 1 !important;\n    display: none;\n}\n\n.container-img-result-searcher [data-similar-images-icon] {\n    display: none;\n}\n\n.overlay {\n    position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
